import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { PARLAY_STORAGE_KEY, setParlayEnabled } from '@/store/slices/parlaySlice';

export const useParlay = () => {
  const dispatch = useAppDispatch();

  const isParlayEnabled = useAppSelector((state) => state.parlay.isParlayEnabled);

  const setIsParlayEnabled = useCallback(
    (value: boolean) => {
      dispatch(setParlayEnabled(value));

      window.setTimeout(() => {
        window.localStorage.setItem(PARLAY_STORAGE_KEY, String(value));
      }, 0);
    },
    [dispatch]
  );

  const toggleParlay = useCallback(() => {
    setIsParlayEnabled(!isParlayEnabled);
  }, [isParlayEnabled, setIsParlayEnabled]);

  return {
    isParlayEnabled,
    setIsParlayEnabled,
    toggleParlay,
  };
};
